var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74 16.14C10.345 14.13 14 9.255 14 6.516 14 3.194 11.312.5 8 .5 4.687.5 2 3.194 2 6.516c0 2.738 3.656 7.613 5.26 9.624a.943.943 0 0 0 1.48 0ZM8 4.51a2.008 2.008 0 0 1 0 4.01c-.53 0-1.04-.21-1.414-.587A2.008 2.008 0 0 1 8 4.51Z"
  })));
};
export default SvgAddress;